import { makeStyles } from '@material-ui/core';
import themes from 'styles/themes';

export const useStyles = makeStyles((theme) => ({
    drawer: {
        borderTopRightRadius: 20,
        borderTopLeftRadius: 20,
        paddingTop: '16px',
        background: 'white',
    },
    shareTitle: {
        fontFamily: 'PoppinsRegular',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '18px',
        lineHeight: '24px',
        color: themes.palette.primary.main,
    },
    shareContent: {
        paddingBottom: 20,
        paddingTop: 10,
        display: 'flex',
        flex: 1,
        overflow: 'auto',
        justifyContent: 'center',
    },
    linkButton: {
        backgroundColor: '#CCDADB !important',
        transform: 'rotateY(180deg) rotate(45deg)',
        color: 'white !important',
        margin: 10,
    },
    instagramButton: {
        background:
            'radial-gradient(92.18% 99.11% at 26.56% 107.7%, #FFDD55 0%, #FFDD55 10%, #FF543E 50%, #C837AB 100%) !important',
        color: 'white !important',
        margin: 10,
    },
    mailBtn: {
        backgroundColor: '#FFFFFF',
        border: '1px solid #E8F0F1',
        color: '#4A6C72 !important',
        margin: 10,
    },
    whtsAppBtn: {
        backgroundColor: '#65D072',
        color: 'white !important',
        margin: 10,
    },
    moreBtn: {
        backgroundColor: '#CCDADB !important',
        color: 'white !important',
        margin: 10,
    },
    copyMsg: {
        backgroundColor: themes.palette.primary.light,
        fontFamily: 'PoppinsRegular',
        fontStyle: 'normal',
        textAlign: 'center',
        color: themes.palette.primary.main,
        padding: '10px',
    },
    noneCopyMsg: {
        visibility: 'hidden',
        padding: '10px',
    },
    successIcon: {
        color: themes.palette.primary.main,
        marginRight: 5,
    },
    closeIcon: {
        position: 'absolute',
        right: 10,
        color: themes.palette.primary.main,
    },
    iconLabel: {
        fontFamily: 'PoppinsRegular',
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '12px',
        lineHeight: '14px',
        color: themes.palette.primary.main,
    },
}));
